module.exports = {"id":"215057","name":"Iván Marcone","rating":"79","photo":"./data/images/photos/3/215057.png","club":{"name":"Lanús","logo":"./data/images/clubs/Lanus.png"},"positions":["MDC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IvanMarcone0.json
// module id = 1841
// module chunks = 0